/**
 * Shared constants for money and billing math.
 *
 * Invariant (see docs/conventions.md): all monetary and hour values are SQL `decimal`
 * end-to-end and computed with a decimal library on the backend — never JS floats.
 * These constants document the rounding contract; the authoritative implementation
 * lives in the backend billing engine.
 */
/** Currency rounding: amounts are rounded to whole cents (2 dp). */
export const MONEY_DECIMAL_PLACES = 2;
/** Hours rounding: hour quantities are tracked to 2 dp. */
export const HOURS_DECIMAL_PLACES = 2;
/**
 * Recurring billing cadence for an agreement line. A `monthly` line bills once per
 * calendar month from its start date; a `yearly` line bills once per year.
 */
export const BILLING_FREQUENCIES = ['monthly', 'yearly'];
/** Number of months in one billing cycle for each frequency. */
export const BILLING_FREQUENCY_MONTHS = {
    monthly: 1,
    yearly: 12,
};
//# sourceMappingURL=billing.js.map